import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RoleBasedProtectedRoute from "./ProtectedRoute";
import Loader from "../comman/Loader.js";
import useAuth from "../Pages/Auth.js";
import LiveStramOfYoutube from "../component/Events/LiveStreamOfYoutube.js";
import PartnerDashboardPage from "../partner/components/partnerDashboard.js";
import PartnerRequest from "../component/Admin/partner/partnerRequest.js";
import PartnerProfile from "../component/Admin/partner/PartnerDetails.js";
import PartnerHomePage from "../component/Admin/partner/PartnerHomePage.js";
import AllPartners from "../component/Admin/partner/AllPartners.js";
import AdminDashboardPage from "../component/Admin/components/AdminDashboardPage.js";
import Partner from "../partner/components/partner.js";
import PartnerHome from "../partner/components/PartnerHome.js";
import PunchLead from "../component/Minicrm/PunchLead.js";
import AssignedLeads from "../caller/AssignedLeads.js";
import CallerDashboard from "../caller/CallerDashBoard.js";
import DealsTable from "../caller/ConvertedDeals.js";
import PartnerDeals from "../partner/components/PartnerDeals.js";
import PartnerLeads from "../partner/components/PartnerLeads.js";
import NotificationSender from "../component/Admin/notification/notify.js";
import PartnerWithdrawals from "../Withdral/PartnerWithdrawals.js";
import AdminWithdrawals from "../Withdral/AdminWithdrawals.js";
import PartnerWithdrawalsHistory from "../partner/components/PartnerWithdrawalHistory.js";
import TeacherMarketPage from "../component/Teacher/TeacherMarketPage.js";
import ShowTheAnalystById from "../component/Teacher/market/ShowTheAnalystById.js";
import EbookDetailsPage from "../Pages/EbookDetailsPage.js";
import CouponForm from "../component/Admin/components/CouponForm.js";
import CreateEbookPage from "../Ebooks/CreateEbookPage.js";
const PageNotFound = lazy(() => import("../Pages/PageNotFound"));
const ProfilePage = lazy(() => import("../Pages/profile/Profile"));
const Teacher = lazy(() => import("../Pages/Teacher"));
const AddVideoForm = lazy(() => import("../component/Teacher/UploadVideo"));
const CourseDetails = lazy(() => import("../component/student/CourseDetails"));
const PurchasedCourse = lazy(
  () => import("../component/student/PurchasedCourse.js")
);
const Cartpage = lazy(() => import("../component/student/Cartpage.js"));
const CourseVideosPage = lazy(
  () => import("../component/student/CourseVideo.js")
);
const VideosByCourse = lazy(
  () => import("../component/Teacher/VideosByCourse.js")
);
const Home = lazy(() => import("../Pages/HomePage"));
const TeacherDashboard = lazy(
  () => import("../component/Teacher/TeacherDashboard.js")
);
const AllCourses = lazy(() => import("../component/student/AllCourse..js"));
const CreateExpert = lazy(() => import("../component/Experts/CreateEpert.js"));
const ExpertDetails = lazy(
  () => import("../component/Experts/ExpertDetails.js")
);
const ResponsiveExpertsPageForAllDivices = lazy(
  () => import("../component/Experts/ResponsiveExpertsPageForAllDivices.js")
);
const ReportsPage = lazy(() => import("../component/Teacher/ReportsPage.js"));
const TeacherProfile = lazy(
  () => import("../component/Teacher/TeacherProfile.js")
);
const ContactUs = lazy(() => import("../Pages/ContactUs.js"));
const AboutUs = lazy(() => import("../Pages/profile/AboutUs.js"));
const PrivacyPolicy = lazy(() => import("../Pages/profile/Pricy-Policy.js"));
const TermsConditions = lazy(
  () => import("../Pages/profile/Term-Condition.js")
);
const ContactUsPage = lazy(() => import("../Pages/ContactUsPage.js"));
const MarketPage = lazy(() => import("../Pages/MarketPage.js"));
const AdminDashboard = lazy(() => import("../Pages/Admin-Dashboard.js"));
const Strategies = lazy(() => import("../component/Admin/Strategies.js"));
const StrategyPurchasedPage = lazy(
  () => import("../Pages/StrategyPurchasedPage.js")
);

const StrategyVideoPlayPage = lazy(
  () => import("../Pages/StrategyVideoPlayPage.js")
);
const StrategyPayments = lazy(
  () => import("../component/Admin/components/StrategyPayments.js")
);
const UserList = lazy(
  () => import("../component/Admin/components/UserList.js")
);
const StudentPayments = lazy(
  () => import("../component/Admin/components/StudentPayments.js")
);
const BecomeInstructor = lazy(
  () => import("../component/Teacher/BecomeanInstructor.js")
);
const BecomePartner = lazy(() => import("../Pages/BecomeaPartner.js"));
const LiveWebinar = lazy(
  () => import("../component/mobile/student/Webinar/LiveWebinar.js")
);
const WorkShop = lazy(() => import("../component/mobile/WorkShop/workShop.js"));
const CreateWebinar = lazy(
  () => import("../component/mobile/student/Webinar/CreateWebinar.js")
);
const UpcomingCourses = lazy(
  () => import("../component/Events/UpcomeingCourses.js")
);
const WebinarPlayer = lazy(
  () => import("../component/mobile/student/Webinar/WebinarPlayer.js")
);
const WebinarShowPage = lazy(
  () => import("../component/mobile/student/Webinar/WebinarShowPage.js")
);
const SignupPage = lazy(() => import("../Pages/SignupPage"));
const LoginPage = lazy(() => import("../Pages/LoginPage"));
const ForgotPasswordPage = lazy(() => import("../Pages/ForgotPasswordPage"));
const SetPasswordPage = lazy(() => import("../Pages/SetPasswordPage"));
const DashboardPage = lazy(() => import("../Pages/DashboardPage"));

const AppRoutes = () => {
  const { loading, isAuthenticated } = useAuth();

  if (loading) {
    return <div className="loading-screen">Loading...</div>;
  }

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* partner dashboard */}
        <Route
          path="/partner/dashboard"
          element={
            <RoleBasedProtectedRoute allowedRoles={["partner"]}>
              <PartnerDashboardPage />
            </RoleBasedProtectedRoute>
          }
        >
          <Route
            path="/partner/dashboard"
            element={
              <RoleBasedProtectedRoute allowedRoles={["partner"]}>
                <PartnerHome />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/partner/dashboard/profile"
            element={
              <RoleBasedProtectedRoute allowedRoles={["partner"]}>
                <Partner />
              </RoleBasedProtectedRoute>
            }
          />

          <Route
            path="/partner/dashboard/createlead"
            element={<PunchLead allowedRoles={["partner"]} />}
          />
          <Route
            path="/partner/dashboard/my-leads"
            element={<PartnerLeads allowedRoles={["partner"]} />}
          />
          <Route
            path="/partner/dashboard/my-deals"
            element={<PartnerDeals allowedRoles={["partner"]} />}
          />
          <Route
            path="/partner/dashboard/withdrawal-history"
            element={<PartnerWithdrawalsHistory allowedRoles={["partner"]} />}
          />
        </Route>
        {/* Teacher Dashboard */}
        <Route
          path="/dashboard"
          element={
            <RoleBasedProtectedRoute allowedRoles={["teacher"]}>
              <DashboardPage />
            </RoleBasedProtectedRoute>
          }
        >
          {/* Nested Routes */}
          <Route
            path="/dashboard"
            element={
              <RoleBasedProtectedRoute allowedRoles={["teacher"]}>
                <TeacherDashboard />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/dashboard/reports"
            element={
              <RoleBasedProtectedRoute allowedRoles={["teacher"]}>
                <ReportsPage />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/dashboard/analyst"
            element={
              <RoleBasedProtectedRoute allowedRoles={["teacher"]}>
                <TeacherMarketPage />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/dashboard/analyst/:analystId"
            element={
              <RoleBasedProtectedRoute allowedRoles={["teacher"]}>
                <ShowTheAnalystById />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/dashboard/webinar"
            element={
              <RoleBasedProtectedRoute allowedRoles={["teacher"]}>
                <CreateWebinar />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/dashboard/webinar/:webinarId"
            element={
              <RoleBasedProtectedRoute allowedRoles={["teacher"]}>
                <WebinarShowPage />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/dashboard/profile"
            element={
              <RoleBasedProtectedRoute allowedRoles={["teacher"]}>
                <TeacherProfile />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="video-upload"
            element={
              <RoleBasedProtectedRoute allowedRoles={["teacher"]}>
                <Teacher />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="video-upload/:courseId"
            element={
              <RoleBasedProtectedRoute allowedRoles={["teacher"]}>
                <AddVideoForm />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="course-videos/:courseId"
            element={
              <RoleBasedProtectedRoute allowedRoles={["teacher"]}>
                <VideosByCourse />
              </RoleBasedProtectedRoute>
            }
          />
        </Route>
        {/* Admin Dashboard */}
        <Route
          path="/admin-dashboard"
          element={
            <RoleBasedProtectedRoute allowedRoles={["admin"]}>
              <AdminDashboard />
            </RoleBasedProtectedRoute>
          }
        >
          <Route
            path="/admin-dashboard"
            element={
              <RoleBasedProtectedRoute allowedRoles={["admin"]}>
                <AdminDashboardPage />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard/strategies"
            element={
              <RoleBasedProtectedRoute allowedRoles={["admin"]}>
                <Strategies />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard/strategypayments"
            element={
              <RoleBasedProtectedRoute allowedRoles={["admin"]}>
                <StrategyPayments />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard/users"
            element={
              <RoleBasedProtectedRoute allowedRoles={["admin"]}>
                <UserList />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard/coursePayments"
            element={
              <RoleBasedProtectedRoute allowedRoles={["admin"]}>
                <StudentPayments />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard/partner"
            element={
              <RoleBasedProtectedRoute allowedRoles={["admin"]}>
                <PartnerHomePage />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard/notify"
            element={
              <RoleBasedProtectedRoute allowedRoles={["admin"]}>
                <NotificationSender />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard/partner/requests"
            element={
              <RoleBasedProtectedRoute allowedRoles={["admin"]}>
                <PartnerRequest />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard/partner/allpartner"
            element={
              <RoleBasedProtectedRoute allowedRoles={["admin"]}>
                <AllPartners />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard/partner/info/:partnerId"
            element={
              <RoleBasedProtectedRoute allowedRoles={["admin"]}>
                <PartnerProfile />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard/admin-withdrawals"
            element={
              <RoleBasedProtectedRoute allowedRoles={["admin"]}>
                <AdminWithdrawals />
              </RoleBasedProtectedRoute>
            }
          />
          {/* <Route path="/admin-dashboard/admin-withdrawals" element={<AdminWithdrawals />} /> */}
        </Route>
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/" element={<Home />} />
        <Route path="/ebook/:id" element={<EbookDetailsPage />} />
        <Route path="/all-courses" element={<AllCourses />} />
        <Route
          path="/strategypurchased"
          element={
            <RoleBasedProtectedRoute allowedRoles={["student"]}>
              <StrategyPurchasedPage />
            </RoleBasedProtectedRoute>
          }
        />
        <Route path="/market" element={<MarketPage />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/termsconditon" element={<TermsConditions />} />
        <Route path="/contactUs" element={<ContactUsPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/password/forgot" element={<ForgotPasswordPage />} />
        <Route path="/password/reset/:token" element={<SetPasswordPage />} />
        <Route
          path="/profile"
          element={
            <RoleBasedProtectedRoute
              allowedRoles={["student", "teacher", "admin", "partner"]}
            >
              <ProfilePage />
            </RoleBasedProtectedRoute>
          }
        />
        <Route path="/becomeainstructor" element={<BecomeInstructor />} />
        <Route path="/becomeapartner" element={<BecomePartner />} />
        <Route
          path="/createwebinar"
          element={
            <RoleBasedProtectedRoute allowedRoles={["teacher"]}>
              <CreateWebinar />
            </RoleBasedProtectedRoute>
          }
        />
        <Route path="/upcomeingcourses" element={<UpcomingCourses />} />
        <Route path="/livestram" element={<LiveStramOfYoutube />} />
        <Route
          path="/video-player"
          element={
            <RoleBasedProtectedRoute>
              <WebinarPlayer />
            </RoleBasedProtectedRoute>
          }
        />
        <Route path="/student/course/:courseId" element={<CourseDetails />} />
        <Route
          path="/student/purchased"
          element={
            <RoleBasedProtectedRoute>
              <PurchasedCourse />
            </RoleBasedProtectedRoute>
          }
        />
        <Route
          path="/student/purchased/:courseId/videos"
          element={
            <RoleBasedProtectedRoute>
              <CourseVideosPage />
            </RoleBasedProtectedRoute>
          }
        />
        <Route path="/student/cart" element={<Cartpage />} />
        <Route
          path="/student/webinar"
          element={
            <RoleBasedProtectedRoute allowedRoles={["student"]}>
              <LiveWebinar />
            </RoleBasedProtectedRoute>
          }
        />
        <Route
          path="/student/workshops"
          element={
            <RoleBasedProtectedRoute allowedRoles={["student"]}>
              <WorkShop />
            </RoleBasedProtectedRoute>
          }
        />
        <Route path="*" element={<PageNotFound />} />
        <Route
          path="/strategy/:strategyId"
          element={
            <RoleBasedProtectedRoute allowedRoles={["student"]}>
              <StrategyVideoPlayPage />
            </RoleBasedProtectedRoute>
          }
        />
        <Route
          path="/expert"
          element={
            <RoleBasedProtectedRoute
              allowedRoles={["student", "admin", "partner"]}
            >
              <ResponsiveExpertsPageForAllDivices />
            </RoleBasedProtectedRoute>
          }
        />
        <Route
          path="/createexperts"
          element={
            <RoleBasedProtectedRoute allowedRoles={["admin"]}>
              <CreateExpert />
            </RoleBasedProtectedRoute>
          }
        />
        <Route
          path="/experts/:id"
          element={
            <RoleBasedProtectedRoute allowedRoles={["student"]}>
              <ExpertDetails />
            </RoleBasedProtectedRoute>
          }
        />

        <Route
          path="/caller-dashboard"
          element={
            <RoleBasedProtectedRoute allowedRoles={["caller"]}>
              <CallerDashboard />
            </RoleBasedProtectedRoute>
          }
        >
          {/* Nested route for AssignedLeads */}
          <Route
            path="assignedleads"
            element={
              <RoleBasedProtectedRoute allowedRoles={["caller"]}>
                <AssignedLeads />
              </RoleBasedProtectedRoute>
            }
          />
          <Route
            path="my-deals"
            element={
              <RoleBasedProtectedRoute allowedRoles={["caller"]}>
                <DealsTable />
              </RoleBasedProtectedRoute>
            }
          />
        </Route>

        <Route path="/partner-withdrawals" element={<PartnerWithdrawals />} />
        <Route path="/createebook" element={<CreateEbookPage />} />
        {/* <Route path="/assigncoupon" element={<CouponForm />} /> */}
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;

{
  /* <Route path="/ebook/:id" element={<EbookDetailsPage />} /> */
}
